module.exports = 'M11.8 15.367V.824h5.003v7.863h.137L20.02.824h4.178v7.863h.11l2.53-7.863h5.25l-5.36 14.543h-5.966l-.413-5.14h-.192l-2.117 5.14H11.8zM10.891.824v1.237L.088.824h10.804zm0 2.64V4.7L.088 3.463h10.804zm0 2.638V7.34L.088 6.102h10.804zm0 2.64v1.237L.088 8.742h10.804zm0 2.639v1.237L.088 11.38h10.804zm0 2.666v1.237L.088 14.047h10.804z'



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icon/paths/logo.js